import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.62 11c0-3.75 0-5.625.954-6.939A5 5 0 0 1 5.68 2.955C6.995 2 8.87 2 12.62 2c3.749 0 5.624 0 6.938.955.425.308.798.682 1.106 1.106.955 1.314.955 3.19.955 6.939v2c0 3.75 0 5.625-.955 6.939a5 5 0 0 1-1.106 1.106C18.244 22 16.368 22 12.62 22s-5.624 0-6.939-.955a5 5 0 0 1-1.106-1.106C3.62 18.625 3.62 16.749 3.62 13zM15.62 7h-8m3 5h-3"
    }, null, -1)
  ])))
}
export default { render: render }